export default {
  methods: {
    openArchbee(docId) {
      // eslint-disable-next-line no-underscore-dangle
      window._archbee.push({ eventType: 'show-widget', docId });
    },
  },
};
